import { BonusCurrency, UsdCurrency, UsdtCurrency } from '@flipster/utils/constants/currency';

import { Currency } from './types';

const defaultMinConfirmations = 1;

export function currencyV1Instance(currency: Currency): CurrencyV2Instance {
  const isUSD = currency.currency === UsdCurrency;
  const isUSDT = currency.currency === UsdtCurrency;
  const isBonus = currency.currency === BonusCurrency;

  let subLabel = currency.currency;
  if (isBonus) subLabel = 'Your Flipster rewards!';

  return {
    ...currency,
    isUSD,
    isUSDT,
    isBonus,
    subLabel,
    englishName: isBonus ? 'BONUS' : currency.englishName,
    conversionUnit: currency.conversionUnit ?? '0.0001',
    getMinConfirmation(networkName: string | undefined) {
      if (!networkName) return defaultMinConfirmations;
      const blockchainInfo = currency.blockchainInfo.find((bi) => bi.networkName === networkName);
      return blockchainInfo?.minConfirmations ?? defaultMinConfirmations;
    },
  };
}

export interface CurrencyV2Instance extends Currency {
  isUSD: boolean;
  isUSDT: boolean;
  isBonus: boolean;
  subLabel: string;
  englishName: string;
  conversionUnit: string;
  getMinConfirmation(networkName: string | undefined): number;
}
